import { render, staticRenderFns } from "./CardTarjaEnqueteTVZ.vue?vue&type=template&id=60278c0e&scoped=true"
import script from "./CardTarjaEnqueteTVZ.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteTVZ.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteTVZ.vue?vue&type=style&index=0&id=60278c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60278c0e",
  null
  
)

export default component.exports